import { useTranslation } from "react-i18next";
import LegalPage, { LegalSection } from "@/components/LegalPage";

const TermsAndConditions = () => {
  const { t } = useTranslation();
  const sections = t("legal.terms.sections", { returnObjects: true }) as LegalSection[];

  return (
    <LegalPage
      seoTitle={t("legal.terms.seoTitle")}
      seoDescription={t("legal.terms.seoDescription")}
      keywords={t("legal.terms.keywords")}
      url="https://masshappy.com/terminos"
      title={t("legal.terms.title")}
      sections={Array.isArray(sections) ? sections : []}
      contactTitle={t("legal.terms.contactTitle")}
      contactIntro={t("legal.terms.contactIntro")}
      contactLines={[t("legal.terms.email"), t("legal.terms.phone")]}
      updated={t("legal.terms.updated")}
    />
  );
};

export default TermsAndConditions;
